import React from "react";
import {useFormikContext} from "formik";
import LineComponent from "../../../../../common/ui/Line";

export default function CyberAssuranceProtection3({translation, printRef}) {
    const formikProps = useFormikContext();

    return (
        <div ref={printRef}>
            <div className={'item'}>
                <h5>{translation("ASSISTA_Generic_Form_Label_Step3")}</h5>
            </div>

            <div className={'item'}>
                <h6>{translation("ASSISTA_Generic_Form_Field_Damage_Date")}</h6>
                <p>{formikProps.values['assistaDateDamage']}</p>
            </div>

            <div className={'item'}>
                <h6>{formikProps.values['damageCauseLabel']}</h6>
            </div>

            <div className={'item'}>
                <h6>{translation("ASSISTA_Generic_Form_Field_Damage_Description")}</h6>
                <p>{formikProps.values['assistaCaseDamage']}</p>
            </div>

            <LineComponent/>

            <div className={'item-names'}>
                <div>
                    <h6>{translation('firstnameLabel')}</h6>
                    <p>{formikProps.values['assistaCounterpartyFirstname']}</p>
                </div>
                <div>
                    <h6>{translation('surnameLabel')}</h6>
                    <p>{formikProps.values['assistaCounterpartyName']}</p>
                </div>
            </div>

            <div className={'item'}>
                <div>
                    <h6>{translation('holderLabel')}</h6>
                    <p>{formikProps.values['assistaCounterpartyCompany']}</p>
                </div>
            </div>

            <div className={'item'}>
                <div>
                    <h6>{translation('addressLabel')}</h6>
                    <p>{formikProps.values['assistaCounterpartyAddress']}</p>
                </div>
            </div>

            <div className={'item-street'}>
                <div>
                    <h6>{translation('npaLabel')}</h6>
                    <p>{formikProps.values['assistaCounterpartyAddressNPA']}</p>
                </div>
                <div>
                    <h6>{translation('cityLabel')}</h6>
                    <p>{formikProps.values['assistaCounterpartyAddressCity']}</p>
                </div>
            </div>

            <div className={'item'}>
                <h6>{translation('landLabel')}</h6>
                <p>{formikProps.values['assistaCounterpartyAddressLand']}</p>
            </div>

            <LineComponent/>
        </div>
    )
}